import bus from 'public/utils/bus'
import store from 'public/store'
import { AutoComplete } from './index'


bus.$once('APP_LOADED', initAutoComplete)

function initAutoComplete() {
  const lookUpOptions = store.getters.lookUpOptions
  const [autocompleteSwitch] = lookUpOptions['sys_input_autocomplete_switch'] || []
  const blacklist = lookUpOptions['sys_input_autocomplete_blacklist'] || []
  const blackRouter = lookUpOptions['sys_input_autocomplete_blackRouter'] || []
  const whitelistRouter = lookUpOptions['sys_input_autocomplete_whitelistRouter'] || []
  if (autocompleteSwitch.value === '1') {
    try {
      // eslint-disable-next-line no-unused-vars
      const autoCompleteInstance = new AutoComplete({
        blacklist: blacklist.map(item => item.value),
        blackRouter: blackRouter.map(item => item.value),
        whitelistRouter: whitelistRouter.map(item => item.value),
      })
    } catch (e) {
      console.log('error', e)
    }
  }
}



// WEBPACK FOOTER //
// ./src/layout/layout/setup/input-autocomplete/init.js